<div class="row mb-3">
  <div class="col-md-6">
    <h2>POS Terminals</h2>
    <p class="text-muted">Manage physical POS terminals for this store</p>
  </div>
  <div class="col-md-6 text-end">
    <button class="btn btn-outline-secondary me-2" (click)="onBackToStores()">
      <nb-icon icon="arrow-back-outline"></nb-icon>
      Back to Stores
    </button>
    <button class="btn btn-primary" (click)="onCreate()">
      <nb-icon icon="plus-outline"></nb-icon>
      Create Terminal
    </button>
  </div>
</div>

<div class="col-12">
  <nb-card>
    <nb-card-body>
      <div class="table-responsive">
        <table class="table text-center">
          <thead>
            <tr>
              <th>Name</th>
              <th>Assigned login</th>
              <th>Scanner</th>
              <th>Printer</th>
              <th>Payment Method</th>
              <th>NFC</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let terminal of terminals">
              <td>
                <strong>{{ terminal.terminalName }}</strong>
                <nb-badge
                  *ngIf="terminal.smartTillEnabled"
                  text="Smarttill"
                  status="warning"
                  class="ms-2">
                </nb-badge>
              </td>
              <td>
                <span *ngIf="terminal.assignedUserId" [nbTooltip]="terminal.assignedUserId.email">
                  {{ terminal.assignedUserId.name }}
                </span>
                <span *ngIf="!terminal.assignedUserId" class="text-muted">—</span>
              </td>
              <td>{{ scannerLabel(terminal.preferredScannerType) }}</td>
              <td>
                <nb-badge
                  [text]="terminal.receiptPrinterEnabled ? 'Enabled' : 'Disabled'"
                  [status]="terminal.receiptPrinterEnabled ? 'success' : 'basic'">
                </nb-badge>
              </td>
              <td>{{ paymentLabel(terminal.preferredPaymentMethod) }}</td>
              <td>
                <nb-badge
                  [text]="terminal.nfcReaderEnabled ? 'Enabled' : 'Disabled'"
                  [status]="terminal.nfcReaderEnabled ? 'info' : 'basic'">
                </nb-badge>
              </td>
              <td>
                <nb-badge
                  [text]="terminal.isActive ? 'Active' : 'Inactive'"
                  [status]="terminal.isActive ? 'success' : 'danger'">
                </nb-badge>
              </td>
              <td>
                <nb-icon
                  style="cursor: pointer"
                  class="right"
                  icon="edit-outline"
                  nbTooltip="Edit Terminal"
                  (click)="onEdit(terminal)">
                </nb-icon>
                <nb-icon
                  style="cursor: pointer"
                  class="right deleteIcon ms-2"
                  icon="slash-outline"
                  nbTooltip="Disable Terminal"
                  (click)="onDelete(terminal)">
                </nb-icon>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="terminals.length === 0" class="text-center py-5">
        <nb-icon icon="monitor-outline" style="font-size: 3rem; opacity: 0.4;"></nb-icon>
        <h5 class="mt-3">No terminals configured</h5>
        <p class="text-muted">Click "Create Terminal" to add one.</p>
      </div>
    </nb-card-body>
  </nb-card>
</div>

<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="large" [fullScreen]="true" color="white" type="ball-circus">
  <p style="color: white">Loading...</p>
</ngx-spinner>
